import axios from 'axios';
import { buildRevJetBanner, buildRevJetBannerMock } from './revjet';
import { getUrlParams, getSkus } from './helpers';

const PARAMS_VALIDATION = {
  default: {
    required: ['schema', 'browserid', 'appid'],
    optional: ['appName', 'customerType', 'storeid'],
  },

  cat_sponsored: {
    required: ['category'],
    optional: [],
  },

  browse_sponsored: {
    required: ['category'],
    optional: ['organicskus'],
  },

  search_sponsored: {
    required: ['keyword', 'organicskus'],
    optional: ['category'],
  },

  pip_sponsored: {
    required: ['viewedsku', 'organicskus']
  }
};

function isValidRequest(queryParams) {
  const requiredDefaultParams = PARAMS_VALIDATION.default.required;

  for (let i = 0; i < requiredDefaultParams.length; i += 1) {
    const paramKey = requiredDefaultParams[i];

    if (!queryParams[paramKey]) {
      return false;
    }
  }

  return true;
}

function getOrganicSkus({ pageContext, eventBusData }) {
  let skus;
  if (eventBusData?.fbtSkus) {
    skus = eventBusData.fbtSkus.join();
  } else {
    skus = getSkus(pageContext);
  }

  if (skus) {
    skus = encodeURIComponent(skus);
  }

  return skus;
}

function getViewedSku({ pageContext }) {
  return pageContext?.data?.itemId;
}

function getEventFilterIds({ data }) {
  let filterId = '';

  if (data && data.searchModel && data.searchModel.appliedDimensions) {
    data.searchModel.appliedDimensions.forEach((element) => {
      if (element.label === 'The Home Depot Events') {
        element.refinements.forEach((ref) => {
          filterId = ref.refinementKey;
        });
      }
    });
  }

  return filterId;
}

function getCustomerType({ experienceContext }) {
  let customerType = 'b2c';

  if (experienceContext?.customer?.type === 'b2b') {
    customerType = 'b2b';
  }

  return customerType;
}

function getApiMockParam() {
  let params = getUrlParams(window.location.href);
  let mock = '';

  if (params.useSponsoredMock) {
    mock = true;
  }

  return mock;
}

function getQueryParams(requestConfig) {
  const queryParams = {};

  queryParams.schema = requestConfig.schema;
  queryParams.appid = requestConfig.experienceContext.channel === 'desktop' ? 'desktop' : 'mobileweb';

  const browserid = requestConfig.experienceContext.cookie?.adobeCookie?.MCMID;
  if (browserid) {
    queryParams.browserid = browserid;
  }

  const category = requestConfig.pageContext.data?.searchModel?.metadata?.categoryID;
  if (category) {
    queryParams.category = category;
  }

  const organicskus = getOrganicSkus(requestConfig);
  if (organicskus) {
    queryParams.organicskus = organicskus;
  }

  const viewedsku = getViewedSku(requestConfig);
  if (viewedsku) {
    queryParams.viewedsku = viewedsku;
  }

  const customerType = getCustomerType(requestConfig);
  if (customerType) {
    queryParams.customerType = customerType;
  }

  const mock = getApiMockParam();
  if (mock) {
    queryParams.mock = mock;
  }

  const bannerType = requestConfig.bannerType;
  if (bannerType) {
    queryParams.bannerType = bannerType;
  }

  const nValue = getEventFilterIds(requestConfig.pageContext);
  if (nValue) {
    queryParams.nValue = nValue;
  }

  const appName = window?.experienceMetadata?.name;
  if (appName) {
    queryParams.appName = appName;
  }

  const storeid = requestConfig?.experienceContext?.store?.storeId;
  if (storeid) {
    queryParams.storeid = storeid;
  }

  const keyword = requestConfig.pageContext.keyword;
  if (keyword) {
    queryParams.keyword = keyword;
  }

  return queryParams;
}

function getApiUrl(requestConfig) {
  const queryParams = getQueryParams(requestConfig);

  if (!isValidRequest(queryParams)) {
    return null;
  }

  let apiUrl = `/sponsored/v1?show=banner&key=12345678912345678912345678900000&version=model2&_=${Date.now()}`;
  Object.keys(queryParams).forEach((el) => {
    apiUrl += '&' + el + '=' + queryParams[el];
  });

  return apiUrl;
}

function makeApiRequest(requestConfig) {
  const params = getUrlParams(window.location.href);

  if (params.mockSponsoredBannerId) {
    requestConfig.setHasData(true);
    buildRevJetBannerMock(requestConfig);
  } else {
    const apiUrl = getApiUrl(requestConfig);

    axios.get(apiUrl).then((response) => {
      const { data } = response;
      if (data) {
        requestConfig.setHasData(true);
        buildRevJetBanner({ data, requestConfig });
      }
    }).catch((error) => {
      console.log('ERROR: Could not make api request');
    });
  }
}

export {
  makeApiRequest, getOrganicSkus,
  getEventFilterIds, getQueryParams, getApiUrl,
  isValidRequest
};
